<template>
    <div class="nav flex-md-column">
        <h3 class="text-secondary">
            Ročník
        </h3>
        <b-form-select v-model="year" :options="yearOptions" class="mb-2"/>
        <h3 class="text-secondary">
            Kolo
        </h3>
        <b-form-select v-model="course" :options="courseOptions" :disabled="year === null" class="mb-2"/>

        <template v-if="course !== null">
            <h3 class="text-secondary d-none d-md-block">
                Úlohy
            </h3>
            <SubMenuList :submenu="course.subpages.slice(1,) ?? []" :meta="meta"/>
            <div>
                <h3 class="text-secondary">
                    Výsledky
                </h3>
                <SubMenuList :submenu="[course.subpages[0]]" :meta="meta"/>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import { GeneratedMenu, getCzechCourseKindFromUrl } from '@/types';
import { ref, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const props = defineProps<{
    submenu: GeneratedMenu[];
    meta: Partial<{ submenuTitle: string}>
}>();

const route = useRoute();
const path = route.path.split('/');
const yearFromUrl = path.length >= 3 ? path[2] : null;
const czechCourseKindFromUrl = path.length >= 4 ? getCzechCourseKindFromUrl(path[3]) : null;

const yearOptions = [{
    value: null,
    text: 'Vyber ročník',
},
...props.submenu.slice(1).map((item) => ({
    value: item,
    text: item.path.split('/')[2],
}))];

const year = ref(
    yearOptions.find(option => option.text === yearFromUrl)?.value ?? null,
);

const courseOptions = computed(() => {
    if (year.value === null) {
        return [];
    }
    const yearSubmenu = year.value.subpages;

    return [{
        value: null,
        text: 'Vyber kolo',
    },
    ...yearSubmenu.map((item) => ({
        value: item,
        text: getCzechCourseKindFromUrl(item.path.split('/')[3]),
    }))];
});

const course = ref(
    courseOptions.value.find(option => option.text === czechCourseKindFromUrl)?.value ?? null,
);

const router = useRouter();

watch(year, () => {
    // reset the course when year changes
    course.value = null;
    if (year.value) {
        router.push(year.value);
    } else {
        router.push('/archiv/uvod/');
    }
});

watch(course, () => {
    if (course.value) {
        router.push(course.value);
    } else if (year.value) {
        router.push(year.value);
    } else {
        router.push('/archiv/uvod/');
    }
});

watch(route, () => {
    if (route.path === '/archiv/uvod/') {
        year.value = null;
        course.value = null;
    }
});

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@use '@/styles/variables.scss';


.link:hover {
    background: variables.$purple_100;
    border-radius: 8px;
}

/* Small devices (767px and below) */
@media (max-width: 767px) {
.link:hover {
    background: variables.$purple_100;
    border-radius: 8px;
}


}
</style>
